<clp-toolbar [title]="'community.subscribers.title'">
  <button
    type="button"
    class="clp-btn clp-btn-secondary clp-btn-sm inline-flex items-center gap-2"
    (click)="backToCommunities()">
    <i class="fa-solid fa-arrow-left"></i>
    <span>{{ 'general.back' | translate }}</span>
  </button>
</clp-toolbar>

<div class="px-4 py-3">
  @if (loading) {
    <div class="clp-card">
      <div class="clp-card-body flex items-center justify-center py-10 text-sm text-slate-300">
        {{ 'community.subscribers.loading' | translate }}
      </div>
    </div>
  } @else if (!community) {
    <div class="clp-card">
      <div class="clp-card-body flex flex-col items-center gap-3 py-10 text-center">
        <i class="fa-solid fa-users-slash text-3xl text-slate-500"></i>
        <p class="text-sm text-slate-300">{{ 'community.subscribers.noCommunityFound' | translate }}</p>
        <a [routerLink]="['/listCommunities']" class="clp-btn clp-btn-secondary clp-btn-sm">
          {{ 'general.back' | translate }}
        </a>
      </div>
    </div>
  } @else {
    @let members = community.members ?? [];
    @let filteredMembers = getFilteredMembers(members);

    <div class="mb-3 grid grid-cols-1 gap-2 sm:grid-cols-4">
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'community.subscribers.community' | translate }}</p>
        <p class="mt-1 truncate text-sm font-semibold text-slate-100">{{ community.name || '-' }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'community.subscribers.subscription' | translate }}</p>
        <p class="mt-1 truncate text-sm font-semibold text-slate-100">{{ community.subscriptionName || ('community.noSubscription' | translate) }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'community.subscribers.totalSubscribers' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-slate-100">{{ members.length }}</p>
      </div>
      <div class="rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
        <p class="text-xs uppercase tracking-wide text-slate-400">{{ 'community.subscribers.namedSubscribers' | translate }}</p>
        <p class="mt-1 text-xl font-semibold text-emerald-300">{{ getNamedSubscribersCount(members) }}</p>
      </div>
    </div>

    <div class="mb-3 rounded-lg border border-slate-700 bg-slate-900/55 p-2.5">
      <label class="mb-1 block text-xs uppercase tracking-wide text-slate-400">
        {{ 'community.subscribers.subscriber' | translate }}
      </label>
      <div class="relative">
        <i class="fa-solid fa-magnifying-glass pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-slate-500"></i>
        <input
          type="text"
          class="clp-input pl-9"
          [value]="searchTerm"
          (input)="onSearchChange($event)"
          [attr.placeholder]="'community.subscribers.searchPlaceholder' | translate" />
      </div>
    </div>

    @if (members.length === 0) {
      <div class="clp-card">
        <div class="clp-card-body flex flex-col items-center gap-2 py-8 text-center">
          <i class="fa-solid fa-user-slash text-2xl text-slate-500"></i>
          <p class="text-sm text-slate-300">{{ 'community.subscribers.noSubscribers' | translate }}</p>
          <p class="text-xs text-slate-400">{{ 'community.subscribers.noSubscribersDescription' | translate }}</p>
        </div>
      </div>
    } @else if (filteredMembers.length === 0) {
      <div class="clp-card">
        <div class="clp-card-body flex flex-col items-center gap-2 py-8 text-center">
          <i class="fa-solid fa-filter-circle-xmark text-2xl text-slate-500"></i>
          <p class="text-sm text-slate-300">{{ 'community.subscribers.noMatchingSubscribers' | translate }}</p>
        </div>
      </div>
    } @else {
      <div class="overflow-x-auto rounded-lg border border-slate-700 bg-slate-900/55">
        <table class="w-full min-w-[520px] text-sm">
          <thead class="border-b border-slate-700 text-xs uppercase tracking-wide text-slate-400">
            <tr>
              <th class="px-3 py-2 text-left">{{ 'community.subscribers.subscriber' | translate }}</th>
              <th class="px-3 py-2 text-left">{{ 'community.subscribers.subscribedAt' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (member of filteredMembers; track getMemberTrackBy(member, $index)) {
              <tr class="border-t border-slate-700/70">
                <td class="px-3 py-2 text-slate-100">
                  <div class="flex items-center gap-2">
                    @if (getMemberPictureUrl(member.pictureUrl); as memberPictureUrl) {
                      <img [src]="memberPictureUrl" class="member-avatar" alt="" loading="lazy">
                    } @else {
                      <span class="member-avatar member-avatar-fallback">{{ getMemberInitial(member) }}</span>
                    }

                    <span>{{ member.name || ('community.subscribers.unknownSubscriber' | translate) }}</span>
                  </div>
                </td>
                <td class="px-3 py-2 text-slate-300">
                  @if (getSubscriptionTimestamp(member); as subscribedAt) {
                    {{ subscribedAt | translocoDate: { dateStyle: 'medium', timeStyle: 'short' } }}
                  } @else {
                    -
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  }
</div>
